import { RouterModule} from '@angular/router';
import { HomePageComponent } from './homepage/home-page.component';
import { AboutUsComponent } from './about us/about-us.component';
import { ContactFormComponent} from './contactForm/contact-form.component';
import { FaqComponent } from './faq/faq.component';
import { PortfolioComponent} from './portfolio/portfolio.component';
import { ServicesComponent} from './services/services.component';
import {SERVICES_ROUTER } from './services/services.routes';
import {PORTFOLIO_ROUTER } from './portfolio/portfolio.routes'



export const APP_ROUTES = [
  { path: '', component: HomePageComponent},
  { path: 'about', component: AboutUsComponent},
  { path: 'contact', component: ContactFormComponent},
  { path: 'faq', component: FaqComponent},
  { path: 'portfolio', component: PortfolioComponent, children: PORTFOLIO_ROUTER},
  { path: 'services', component: ServicesComponent, children: SERVICES_ROUTER}
];

export const routing = RouterModule.forRoot(APP_ROUTES, { useHash: true });



// WEBPACK FOOTER //
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/app/app.routes.ts